import { Avatar, AvatarFallback } from "ksc-portal-common-components/shadcn"
import React from "react"

export const AvatarComponent = ({
  firstName,
  lastName,
}: {
  firstName?: string
  lastName?: string
}) => (
  <Avatar className="h-10 w-10">
    <AvatarFallback className="bg-primary text-white text-lg font-bold">
      {`${firstName[0] || ""}${lastName[0] || ""}` || "?"}
    </AvatarFallback>
  </Avatar>
)

AvatarComponent.defaultProps = {
  firstName: "",
  lastName: "",
}

export default AvatarComponent
